export const disclaimerClassName = 'disclaimerContainer';
